import React from "react";

function CustomerIcon() {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 23.9993C4.5 21.054 6.888 18.666 9.83333 18.666H15.1667C18.112 18.666 20.5 21.054 20.5 23.9993"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.833 6.20117C23.6743 6.20117 25.1663 7.69317 25.1663 9.53451C25.1663 11.3758 23.6743 12.8678 21.833 12.8678"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.707 6.66118C17.4779 8.43207 17.4779 11.3033 15.707 13.0742C13.9361 14.8451 11.0649 14.8451 9.29399 13.0742C7.5231 11.3033 7.5231 8.43207 9.29399 6.66118C11.0649 4.89028 13.9361 4.89028 15.707 6.66118"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.167 17.333C26.1123 17.333 28.5003 19.721 28.5003 22.6663"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CustomerIcon;
